'use client';

import React, { useState } from 'react';
import moment from 'moment';
import { Button } from 'reactstrap';

import ReviewModal from 'src/components/jobs/review-modal';
import DisplayStarRating from 'src/components/shared/display-star-rating';
import TruncatedText from 'src/components/shared/truncated-text';
import type { JobData } from 'src/types';

interface JobReview {
  rating?: number;
  review_text?: string;
  tenant_name?: string;
  created_at?: string;
  [key: string]: unknown;
}

interface ReviewContainerProps {
  job: JobData | Record<string, unknown>;
}

const ReviewContainer: React.FC<ReviewContainerProps> = ({ job }) => {
  const [showReview, setReview] = useState(false);
  const jobReviews = (job as Record<string, unknown>)?.job_reviews as JobReview[] | undefined;
  const latestRating = jobReviews?.[0];

  return (

    <React.Fragment>
      <div className="rating-outer">
        <div className="rating-wrapper">
          <DisplayStarRating
            ratingValue={latestRating?.rating ?? 0}
            totalStars={5}
            rectFill="#F3F7FF"
          />
        </div>
        <p>
          {latestRating?.rating}
          /5
        </p>
      </div>
      <p className="review-data">
        <span>
          {latestRating?.review_text
            ? (
              <TruncatedText
                textContent={
                  `"${latestRating?.review_text}"`
                }
              />
            ) : ''}
          <div className="reviewer">
            {latestRating?.tenant_name}

            {latestRating?.created_at ? (
              <React.Fragment>
                {' '}
                |
                {' '}
                {moment.utc(latestRating?.created_at).local().format('MMM DD, YYYY hh:mm A')}
              </React.Fragment>
            ) : ''}
            {' '}
            {jobReviews && jobReviews?.length > 1
              ? (
                <React.Fragment>
                  |
                  <Button
                    className="btn-link"
                    color="deoco"
                    onClick={() => setReview(true)}
                  >
                    View All (
                    {jobReviews?.length}
                    )
                  </Button>
                </React.Fragment>
              )
              : ''}
          </div>
        </span>
      </p>
      {showReview && (
        <ReviewModal
          showReview={showReview}
          toggle={() => setReview(false)}
          jobData={job as { jobId?: string; jobNo?: string }}
          source={jobReviews as Array<{ tenant_contact_review_request_id?: string; lula_rating?: string | number; rating?: string | number; review_text?: string; reviewed_by_name?: string; created_at?: string; [key: string]: unknown }>}
        />
      )}
    </React.Fragment>

  );
};

export default ReviewContainer;
